import { render, staticRenderFns } from "./carrierPriceImport.vue?vue&type=template&id=a6f3e2fc"
import script from "./carrierPriceImport.vue?vue&type=script&lang=js"
export * from "./carrierPriceImport.vue?vue&type=script&lang=js"
import style0 from "./carrierPriceImport.vue?vue&type=style&index=0&id=a6f3e2fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports